import api from './api';

export type CostScope = 'CLIENT' | 'ORG' | 'ACCOUNT';

export interface CostExportRequest {
  clientId: string;
  scope: CostScope;
  accountLabel?: string;
  period?: 'current' | 'previous' | { start: string; end: string };
  /** Margen (%) para este reporte. Si se envía, sobreescribe el del cliente. */
  marginOverride?: number | null;
}

export interface CostExportPreview {
  scopeLabel: string;
  period: { start: string; end: string };
  periodLabel: string;
  periodMonth: string;
  marginApplied: number;
  totalCost: number;
  byAccount: { accountId: string; accountName?: string; cost: number }[];
  byService: { service: string; cost: number }[];
}

export interface CostExportResult {
  exportId: string;
  downloadUrl: string;
  totalCost: number;
}

export async function previewCostExport(input: CostExportRequest): Promise<CostExportPreview> {
  const response = await api.post<CostExportPreview>('/cost-exports/preview', input);
  return response.data;
}

export async function generateCostExport(input: CostExportRequest): Promise<CostExportResult> {
  const response = await api.post<CostExportResult>('/cost-exports', input);
  return response.data;
}
